module.exports = __webpack_public_path__ + "static/img/dbq1119.d4f355c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dbq1119.jpg
// module id = gr/M
// module chunks = 0